export default import.meta.ROLLDOWN_FILE_URL_7SbtfowOfna6rPBRW7pgxg